export const PRODUCT_REVIEWS_STATE = "PRODUCT_REVIEWS_STATE"

export const showProductReviews = () => ({
    type: PRODUCT_REVIEWS_STATE,
    payload: {
        visible: true
    }
})

export const closeProductReviews = () => ({
    type: PRODUCT_REVIEWS_STATE,
    payload: {
        visible: false
    }
})